import { gateway } from "../../../gateway";
import { Reminder } from "../interfaces/IRemiders";
import { IResponseReminder } from "../interfaces/response-reminder.interface";

export const getAllRemindersConfig = async (): Promise<Reminder[]> => {
    const { data } = await gateway.get<IResponseReminder>("reminders-settings/");
    return data.data;
};